// Captura, persiste e expõe o código de parceiro (?parc=CODE) — programa de
// afiliados para influencers e parceiros B2B (assessores/cerimonialistas).
//
// Mesmo padrão de referral.js (captura na URL, guarda em localStorage por 30
// dias, limpa a URL), mas em chave e query param SEPARADOS: este programa é
// independente da indicação casal→casal (?ref=) — o mesmo casal pode ter
// vindo de um parceiro E, mais tarde, indicar outros casais.
//
// A validação do código (existe? está ativo?) acontece só no backend, na
// hora de creditar a comissão — aqui só guardamos o valor bruto da URL.

const PARTNER_KEY = 'mdc:partner';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

// Captura ?parc= da URL atual. Chamado uma vez no main.jsx init.
export function capturePartnerFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('parc');
    if (!raw) return;
    const code = String(raw).trim().toUpperCase();
    if (!/^[A-Z0-9-]{3,40}$/.test(code)) return;
    window.localStorage.setItem(PARTNER_KEY, JSON.stringify({ code, savedAt: Date.now() }));
    // Limpa o ?parc= sem deixar histórico extra.
    params.delete('parc');
    const next = window.location.pathname + (params.toString() ? `?${params}` : '') + window.location.hash;
    window.history.replaceState({}, '', next);
  } catch { /* SSR safe */ }
}

export function getActivePartnerCode() {
  try {
    const raw = window.localStorage.getItem(PARTNER_KEY);
    if (!raw) return null;
    const { code, savedAt } = JSON.parse(raw);
    if (Date.now() - savedAt > TTL_MS) {
      window.localStorage.removeItem(PARTNER_KEY);
      return null;
    }
    return code;
  } catch { return null; }
}

export function clearPartnerCode() {
  try { window.localStorage.removeItem(PARTNER_KEY); } catch { /* noop */ }
}
